import KanbanColumnContainer from "./KanbanColumnContainer";

export default KanbanColumnContainer;

/**
 * The lane's loading-state twin. Housed here because it mirrors this
 * component's geometry exactly (width, radius, lane fill) — keeping them in one
 * directory is what stops the skeleton drifting out of alignment with the real
 * lane and making the board jump when data lands.
 */
export { default as KanbanColumnSkeleton } from "./KanbanColumnSkeleton";
